import L from 'leaflet';

export const generateMapMarker = (iconUrl) =>
  L.icon({
    iconUrl,
    iconSize: [25, 41],
    iconAnchor: [12.5, 41],
    popupAnchor: [0, -41]
  });
